enum AuditActionType {
  None = 0, // eslint-disable-line no-unused-vars
  Added = 1, // eslint-disable-line no-unused-vars
  Modified = 2, // eslint-disable-line no-unused-vars
  Deleted = 3, // eslint-disable-line no-unused-vars
}

export const auditActionTypeToString = (value: AuditActionType) => {
  switch (value) {
    case AuditActionType.Added:
      return "Added";
    case AuditActionType.Modified:
      return "Modified";
    case AuditActionType.Deleted:
      return "Deleted";
    default:
      return "";
  }
};

export default AuditActionType;
